import {
  CreateListingCollectionPayload,
  UpdateListingCollectionPayload,
} from "../../../interfaces/ListingCollectionObject";

/** Shared wire shape — create and update take identical bodies (update is a
 *  full replace, not a patch), so both builders funnel through here. */
function toWireBody(
  payload: CreateListingCollectionPayload
): Record<string, unknown> {
  return {
    collectionName: payload.collectionName.trim(),
    // API spec uses `listingIds`; the UI model stores them as `productIds`.
    listingIds: payload.productIds,
    bannerUrl: payload.bannerUrl,
  };
}

/** CreateListingCollectionPayload → POST /api/v1/listing-collections wire body. */
export function buildCreateListingCollectionPayload(
  payload: CreateListingCollectionPayload
): Record<string, unknown> {
  return toWireBody(payload);
}

/** UpdateListingCollectionPayload → PUT /api/v1/listing-collections/{id} wire body.
 *  Full replace, same three fields as create — `uid` is routed into the URL,
 *  never the body. */
export function buildUpdateListingCollectionPayload(
  payload: UpdateListingCollectionPayload
): Record<string, unknown> {
  return toWireBody(payload);
}

export default {
  buildCreateListingCollectionPayload,
  buildUpdateListingCollectionPayload,
};
